import { useState, useEffect, useCallback } from 'react';
import { getAnalytics } from '../lib/analytics';

// Hook for live visitor count
export function useLiveVisitors() {
  const [visitors, setVisitors] = useState(0);
  
  useEffect(() => {
    const analytics = getAnalytics();
    const unsubscribe = analytics.subscribeToLiveVisitors(setVisitors);
    
    return () => unsubscribe();
  }, []);
  
  return visitors;
}

// Hook for venue statistics
export function useVenueStats() {
  const [stats, setStats] = useState({
    totalViews: 0,
    totalDownloads: 0,
    beforeAfterCreated: 0,
    totalShares: 0
  });
  
  useEffect(() => {
    const analytics = getAnalytics();
    const unsubscribe = analytics.subscribeToStats(setStats);
    
    return () => unsubscribe();
  }, []);
  
  return stats;
}

// Hook for today's stats
export function useTodayStats() {
  const [todayStats, setTodayStats] = useState({});
  
  useEffect(() => {
    const analytics = getAnalytics();
    const unsubscribe = analytics.subscribeToDailyStats(setTodayStats);
    
    return () => unsubscribe();
  }, []);
  
  return todayStats;
}

// Hook for tracking actions
export function useTracker() {
  const analytics = getAnalytics();
  
  const trackPhotoView = useCallback((photo) => {
    analytics.trackPhotoView(photo);
  }, [analytics]);
  
  const trackDownload = useCallback((photo) => {
    analytics.trackPhotoDownload(photo);
  }, [analytics]);
  
  const trackBeforeAfter = useCallback(async (beforeYear, afterYear) => {
    return await analytics.trackBeforeAfterCreated(beforeYear, afterYear);
  }, [analytics]);
  
  const trackShare = useCallback((baId, platform) => {
    analytics.trackShare(baId, platform);
  }, [analytics]);
  
  const trackCustom = useCallback((event, data) => {
    analytics.trackEvent(event, data);
  }, [analytics]);
  
  return {
    trackPhotoView,
    trackDownload,
    trackBeforeAfter,
    trackShare,
    trackCustom
  };
}